import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferralComponent } from './referral/referral.component';
import { SharedModule } from '@app/shared';
import { ReferralRoutingModule } from './referral-routing.module';

@NgModule({
  imports: [CommonModule, SharedModule, ReferralRoutingModule],
  declarations: [ReferralComponent],
})
export class ReferralModule {}
